import { render, staticRenderFns } from "./productMount.vue?vue&type=template&id=f5bde1c2&scoped=true"
import script from "./productMount.vue?vue&type=script&lang=js"
export * from "./productMount.vue?vue&type=script&lang=js"
import style0 from "./productMount.vue?vue&type=style&index=0&id=f5bde1c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bde1c2",
  null
  
)

export default component.exports